import React, { useEffect, useState } from 'react'
import routes from 'config/routes'
import { Container,  ModalContent } from './styled'
import { useParams, useNavigate } from 'react-router-dom'
import CommunityHeader from '../communityHeader/view'
import ModalLogin from '../../general/modalLogin/view'
import ModalSignup from 'components/pages/general/modalSignup/view';
import { getCommunityPublic,  joinCommunity } from 'api'
import { Box, Fab, Modal, Button, Grid } from '@mui/material'
import SideMenu from '../sideMenu/view';
import Typography from '@mui/material/Typography';
import noAvatar from '../../../../assets/images/no-avatar.png'
import { getEntityImageUrl, getBackgroundUrl } from '../../../../api/utils'
import coworking from 'assets/images/coworking.jpg'
import AboutUs from './aboutUs';
import Members from './members';
import Activity from './activity';

const CommunitySinglePublic = () => {

  
  const params = useParams()
  const { slug } = params
  const navigate = useNavigate();
  const [community, setCommunity] = useState(null)
  const [member, setMember] = useState(null)
  const [ setFounders] = useState([])
  const [members, setMembers] = useState([])
  const [ setVenues] = useState([])
  const [pastEvents, setPastEvents] = useState([])
  const [upcomingEvents, setUpcomingEvents] = useState([])
  const [ setGallery] = useState(null)
  const [value, setValue] = useState(0);
  const [showAction] = useState(false)
  const [drawerOpen, setDrawerOpen] = useState(true);
  const [communityJoin, setCommunityJoin] = useState(false)
  const [loginMode, setLoginMode] = useState(true)
  const [explainToJoin, setExplainToJoin] = useState(false)
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({
    title: '',
    message: '',
    button: '',
    action: ''
  });

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleChange = (newValue) => {
    setValue(newValue);
  };

  const hadleHeaderAction = () => {
    const data = {
      community: community?.slug,
    }
    joinCommunity(data)
  }

  function getCommunityInfo() {
    getCommunityPublic(slug).then(r => {
      setCommunity(r.group)
      setFounders(r.founders)
      setMembers(r.members)
      setVenues(r.venues)
      setPastEvents(r.past_events)
      setUpcomingEvents(r.upcoming_events)
      setGallery(r.gallery)
    })
      .catch(() => {
        navigate(routes.errorCommunity)
      })
  }
  function setSelectedParticipant(participant) {
    setMember(participant)
  }

  useEffect(() => {
    getCommunityInfo(true)

  }, [])

  const askToJoin = () => {
    setCommunityJoin(true)
    setExplainToJoin(true)
  }

  const avatar = getEntityImageUrl(community, noAvatar)
  const background = getBackgroundUrl(community, coworking)

  const handleSignupSuccess = () => {
    setModalContent({
      title: 'Signup Successful!',
      message: 'We have sent you an email to verify your account. Please check your inbox and click the link to verify your account.',
      button: 'OK',
      action: 'navigate'
    });
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setLoginMode(true)
  };

  return (
    <Container>
      <CommunityHeader title={community?.name} subtitle={community?.single_address} avatar={avatar} background={background} actionTitle='Join Community' actionMethod={hadleHeaderAction} showAction={showAction} />
      <Grid container spacing={2}>
        {/* Left Menu */}
        <Grid item xs={12} md={2}>
          <SideMenu open={drawerOpen} onClose={handleDrawerToggle} changeTab={handleChange} avatar={avatar} title={community?.name} subtitle={community?.single_address} role={'public'} />
        </Grid>
        <Grid item xs={12} md={10}>
          <Box
            component="main"
            sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}
          >
            {value === 0 && <AboutUs community={community} />}
            {value === 1 && <Members members={members} member={member} setMember={setMember} setSelectedParticipant={setSelectedParticipant} tags={[]} />}
            {value === 2 && <Activity community={community} upcomingEvents={upcomingEvents} pastEvents={pastEvents} setCommunityJoin={askToJoin} />}
          </Box>
        </Grid>
      </Grid>
      <Fab
        color="secondary"
        variant="extended"
        aria-label="add"
        sx={{ position: 'fixed', bottom: 32, right: 16 }}
        onClick={() => askToJoin(true)}
      >
        <Typography>Join Community </Typography>
      </Fab>
      <Modal
        open={communityJoin}
        onClose={() => setCommunityJoin(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <ModalContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', flexGrow: 1 }}>
            {explainToJoin &&
              <Typography
                variant="secondary"
                sx={{
                  fontSize: '1.3rem',
                  fontWeight: 700,
                  lineHeight: '1.5',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                  display: 'flex',
                  overflowWrap: 'break-word', // Ensure long words or links break appropriately
                }}
              >
                You need to login or sign up to join this community
              </Typography>}
            {loginMode && <ModalLogin showAction={(mode) => setLoginMode(mode)} setLogin={setCommunityJoin} postAction={{ action: 'joinCommunity', slug: community?.slug }} />}
            {!loginMode && <ModalSignup showAction={(mode) => setLoginMode(mode)} onSuccess={handleSignupSuccess} setLogin={setCommunityJoin} postAction={{ action: 'joinCommunity', slug: community?.slug }} />}
          </Box>
        </ModalContent>
      </Modal>
      <Modal open={modalOpen} onClose={handleCloseModal}>
        <ModalContent>
          <Typography variant="h6">{modalContent.title}</Typography>
          <Typography sx={{ mt: 2 }}>{modalContent.message}</Typography>
          <Grid container justifyContent="center" sx={{ mt: 2 }}>
            <Button onClick={handleCloseModal} variant="contained" color="secondary">
              {modalContent.button}
            </Button>
          </Grid>
        </ModalContent>
      </Modal>
    </Container>
  )
}

CommunitySinglePublic.propTypes = {}

export default CommunitySinglePublic
